// extracted by mini-css-extract-plugin
export default {"title":"Verification_title__H8eCf","text":"Verification_text__IyeJE","button":"Verification_button__IUy7y"};